// import audio from "../../assets/audio/scanner_beep.mp3"
import AppConstant from '../../config/app.constants';

class CheckOutController {
  /*@ngInject*/
  constructor(Auth, $state, User, $translate, UsersService, BranchService, CustomerService, Modal, RouteService, SetupService, RouteStopService,
    DateUtil, DataCounter, WindowService, TruckService, $q, ScanService, ShipmentService, LocationService, ShiptypeService, $location,
    $stateParams, $window, RouteDetailService, Sound, $rootScope, ItemService, CommonLayoutService) {

    this.$translate = $translate
    this.UsersService = UsersService
    this.Auth = Auth
    this.$state = $state
    this.User = User
    this.Modal = Modal
    this.ScanService = ScanService
    this.ShipmentService = ShipmentService
    this.LocationService = LocationService
    this.ShiptypeService = ShiptypeService
    this.SetupService = SetupService
    this.$q = $q
    this.$location = $location
    this.$window = $window
    this.RouteDetailService = RouteDetailService
    this.Sound = Sound
    this.BranchService = BranchService
    this.CustomerService = CustomerService
    this.RouteService = RouteService
    this.WindowService = WindowService
    this.TruckService = TruckService
    this.DataCounter = DataCounter;
    this.CommonLayoutService = CommonLayoutService;
    this.$rootScope = $rootScope;
    // this.audio = this.Sound.errorBeep();
    // this.successAudio = this.Sound.successBeep();
    this.$stateParams = $stateParams
    this.ItemService = ItemService;
    this.checkedoutRoute = '';
    // this.totalCoinShiptype = '';
    // this.shipTypeList = [];
    // this.total = '';
    this.user = null;
    this.finalTruckIdData = null;
    this.finalFromTankerData = '';
    this.responseData = '';
    this.branches = []
    this.customers = []
    this.routes = []
    this.route = []
    this.windows = []
    this.trucks = []
    this.shiptypes = []
    this.routeVerifyData = {};
    this.truckData = {};
    this.destinationData = {
      previouslyScannedId: '',
      destinations: {
        self: null,
        deliveryLoc1: null,
        deliveryLoc2: null,
        deliveryLocCod: null,
        deliveryLocCoin: null
      }
    };

    this.stats = {
      cash: 'cash',
      coin: 'coin',
      items: 'items'
    }

    this.scannerBeep = null;
    this.closedRoute = null;
    this.bagIdCopy = null;
    this.lastScanned = null
    this.bagCheckOutError = '';
    this.bagCheckInMessage = '';
    this.vaultDate = '';
    this.shipmentReportData = [];
    this.virtualTanker = '';
    this.setupData = "";
    this.checkoutTruckLiability = false;
    this.wasItemFound = false;
    this.wasItemThrow = false;
    this.isCheckOutSuccessful = true;
    this.finalToTankerData = "";
    // this.checkOutDate = $location.search().routeDate || null
    this.branchId = this.User.getUser().branchId;
    this.remainingCheckoutItemCount = 0;
    this.remainingForCheckout = null;
    this.resetModel();
    this.disabledBag = false;
    this.isEventFired = false;
    this.isSuccessForceAddBag = false;
    this.isDisabledBag = "";
    // this.bagScanLimit = AppConstant.scanLimit;
    this.bagScanLimit = "";
    this.checkOnlyOnce = false;
    this.checkLength = 0;
    this.enterSuffix = AppConstant.scan_enter_suffix;
    this.remainingToCheckedout = [];
    this.RouteStopService = RouteStopService;
    this.date = "";
    this.DateUtil = DateUtil;
    this.isCheckOutNextRoute = true;
    this.optimizedStops = undefined;
    this.isEnableMultiFunction = AppConstant.isEnableMultiFunction;
    this.routeCheckedOutData;
    this.$rootScope.$broadcast('routeChange', '/app/checkout');
    this.coinCheckOut = '';
    this.autoCheckOut = '';
    this.totalCoinCheckedOut = 0;
    this.totalCashCheckedOut = 0;
    this.checkoutTab = {
      shipment: 'shipment',
      items: 'items'
    };
    this.currentCheckoutTab = this.checkoutTab.shipment;
    this.logisticItemObj = {
      barcode: null,
      itemScanLimitExceed: false,
      allowItemScanOnce: false,
      disableItemScan: false,
      defaultLength: 0,
      lastScannedItem: null,
      lastUpdated: null,
      isError: false,
      itemCheckOutError: null,
      itemCheckOutMessage: null,
      remainingItemList: [],
      checkedOutItemList: [],
      itemDetails: {},
      wasItemFound: false,
      isItemCheckedOut: false,
      remainingItemsCount: 0,
      checkedOutItemsCount: 0,
      errorCode: null
    }
    this.model.routeDetailConfiguration='messenger';
    this.shipmentData = {};
    this.routeDetailConfigurationList = this.CommonLayoutService.configuration();
    this.inventoryBulkCoin = false;
    this.isInventoryBulkCoinOfCOD = false;
  }

  loadWindows() {
    return this.BranchService.get(this.model.branch)
      .then((branch) => {
        this.windows = branch.windows
      })
      .catch((err) => {
        console.log(err)
      })
  }

  loadData() {
    return this.$q.all([
      this.BranchService.all(null, 0, 1000),
      this.RouteService.all(null, 0, 1000),
      // this.TruckService.all(null, 0, 1000),
      this.ShiptypeService.all(null, 0, 1000)
    ])
      .then((res) => {
        this.branches = res[0].results;
        this.routes = res[1].results;
        // this.trucks = res[2].results;
        this.shiptypes = res[2].results;
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal('error.' + err.data.message);
        }
      })
      .finally(() => {
        if (!this.hasRoute) {
          this.focusElementById('route-scan-id');
        }
      })
  }

  verifyRoute(routeId, date) {
    return this.ScanService.routeCheckoutVerify(this.branchId, routeId, date, this.model.messenger)
      .then((data) => {
        this.checkOutData(routeId);
        this.routeVerifyData = data;
        this.logisticItemObj.remainingItemList = this.routeVerifyData.remainingItemList || [];
        this.logisticItemObj.remainingItemsCount = this.logisticItemObj.remainingItemList.length || 0;
        this.logisticItemObj.checkedOutItemList = this.routeVerifyData.checkedOutItemList || [];
        this.logisticItemObj.checkedOutItemsCount = this.logisticItemObj.checkedOutItemList.length || 0;
        this.logisticItemObj.availableItemList = this.routeVerifyData.availableItemList || [];
        this.logisticItemObj.availableItemCount = this.logisticItemObj.availableItemList.length || 0;
        this.remainingCheckoutItemCount = 0;
        this.remainingCashCheckoutItemCount = 0;
        this.remainingCoinCheckoutItemCount = 0;
        this.routeVerifyData.errorCount = 0;
        this.totalCoinVerified = 0;
        this.remainingToCheckedout = [];

        if (this.routeVerifyData.route) {
          this.routeVerifyData.route.forEach((record) => {
            if (!['OK_DELIVERY', 'OK_DELIVERY_ON_HOLD'].includes(record.message)) {
              if (this.coinCheckOut && ['E_DELIVERY_NOT_ON_HOLD'].includes(record.message)) this.remainingCheckoutItemCount++;
              if (!this.coinCheckOut) {
                if ( record.qty && record.coinFlag && !this.routeVerifyData.coinVerified) this.remainingCoinCheckoutItemCount = this.remainingCoinCheckoutItemCount + record.qty;
                else if (record.coinFlag && record.qty && this.routeVerifyData.coinVerified) this.totalCoinVerified = this.totalCoinVerified + record.qty;
                else if (!record.coinFlag && ['E_DELIVERY_NOT_ON_HOLD'].includes(record.message)) this.remainingCashCheckoutItemCount++;
              }
              this.remainingToCheckedout.push(record);
            }
            if (record.isError && ['E_COIN_SHIPMENT_NOT_VERIFIED', 'E_DELIVERY_NOT_ON_HOLD'].includes(record.message)) {
              this.routeVerifyData.errorCount++
            }
          })
          this.routeVerifyData.errorCount = this.routeVerifyData.errorCount + this.logisticItemObj.remainingItemsCount;
        }
      })
  }

  focusElementById(id) {
    setTimeout(() => {
      if (!document.getElementById(id)) return;
      document.getElementById(id).focus()
    })
  }

  getTankerSearchObj(tankerId) {
    const searchObj = {
      queryJSON: {
        rules: [
          {
            field: 'branchId',
            condition: '=',
            data: this.model.branch
          },
          {
            field: 'locationType',
            condition: '=',
            data: 'TANKER'
          }
        ],
        operator: 'AND'
      }
    };

    if (tankerId) {
      searchObj.queryJSON.rules.push({
        field: 'id',
        condition: '=',
        data: tankerId
      });
    }

    return searchObj;
  }

  stopPropagation(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  // get checkedOut shipment based on branchId and routeId
  checkOutData(routeId) {
    this.ScanService.shipmentCheckInCheckOutData(this.model.branch, routeId, this.vaultDate)
      .then((data) => {
        this.totalShipmentCheckedOut = data.checkInCheckOutCount.totalShipmentCheckedOut;
        this.remainingForCheckout = data.checkInCheckOutCount.remainingCheckoutCount;
        this.totalCoinCheckedOut = data.checkInCheckOutCount.totalCoinCheckedOut;
        this.totalCashCheckedOut = data.checkInCheckOutCount.totalCashCheckedOut;
        this.totalCoinShipmentOnRoute = data.checkInCheckOutCount.totalCoinShipmentOnRoute;
        this.remainingCoinCheckoutItemCount = this.totalCoinShipmentOnRoute;
      })
      .catch((err) => {
        console.log(err);
      })
  }

  loadCheckoutDate() {
    this.checkOutDate = this.$location.search().routeDate;

    if (!this.checkInDate) {
      const branchId = this.User.getUser().branchId;

      this.SetupService.get(branchId)
        .then((setup) => {
          this.setupData = setup;
          this.checkoutTruckLiability = setup.checkoutTruckLiability;
          this.virtualTanker = setup.virtualTankerId;
          this.date = this.DateUtil.convertToDate(setup.currentVaultDate);
          this.vaultDate = moment.utc(setup.currentVaultDate).format('YYYY-MM-DD');
          this.checkOutDate = moment(setup.currentVaultDate).utc().format('YYYY-MM-DD');
          this.bagScanLimit = setup.packCharLength;
          this.prefixes = setup.prefixes;
          this.coinCheckOut = setup.coinCheckOut;
          this.addBagToCheckout = setup.addBagToCheckout;

          if (this.setupData.enableAutoSubmit) this.autoSubmitItem = true;
          else this.autoSubmitItem = false;
        })
        .catch((err) => {
          if (err && err.data && err.data.message) {
            this.Modal.errorModal('error.' + err.data.message);
          }
        })
    }
  }

  $onInit() {
    this.model.stats = this.stats.cash;
    this.scannedRouteId = "";
    this.loadData();
    this.loadCheckoutDate();
    this.user = this.User.getUser();
    this.model.branch = this.user.branchId;
    this.loggedInUser = this.user.id;
  }

  routeScanned() {
    var finalRouteData, cloneRouteId;
    this.model.allTrucks = []
    if (this.scannedRouteId === '') {
      return;
    }

    finalRouteData = this.scannedRouteId;
    cloneRouteId = angular.copy(finalRouteData);
    this.closedRoute = undefined;
    this.lastStatusUpdate = undefined;

    const defer = this.$q.defer();
    this.verifyRoute(finalRouteData, this.checkOutDate)
      .then(() => this.ScanService.updateRouteCheckoutStartTime(finalRouteData, this.checkOutDate))
      .then(() => defer.resolve())
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.routeError();
          if (err.data.message === '91510') {
            const errorMessage = this.$translate.instant('error.' + err.data.message, {
              routeId: cloneRouteId.toUpperCase()
            })
            this.Modal.confirm({
              header: this.$translate.instant('errorModal.title'),
              message: this.$translate.instant(errorMessage),
              callback: (({
                modal
              }) => {
                const obj = {
                  routeId: cloneRouteId.toUpperCase(),
                  isRedirected: true
                }
                this.DataCounter.setData(obj);
                this.$state.go('routeControl');
                modal.close();
              }),
              negative: (({
                modal,
              }) => {
                modal.close();
                cloneRouteId = "";
              }),
              buttons: ['routeControl.stop_transfer', 'common.cancel'],
              type: 'danger'
            })
          }
          else {
            this.Modal.errorModal('error.' + err.data.message);
          }
          this.focusElementById('route-scan-id');
        }
      })
      .finally(() => {
        if (this.hasRoute) {
          this.focusElementById('messenger-scan-id');
        } else {
          this.focusElementById('route-scan-id');
        }
        this.scannedRouteId = '';
        this.model.messenger = "";
        finalRouteData = '';
      })
    defer.promise
      .then(() => {
        return this.scanRoute(finalRouteData, this.checkOutDate);
      })
  }

  scanRoute(finalRouteData, checkOutDate) {
    this.ScanService.scanRoute(this.model.branch, finalRouteData, checkOutDate, false, false, false)
      .then((data) => {
        if (data.error) {
          return this.Modal.errorModal(data.error)
        }

        this.model.route = data.route.routeId
        this.model.routeObj = data.route
        this.model.toTruck = data.route.vehicleId
        this.model.loadTruckFlag = data.route.loadTruck
        this.autoCheckOut = data.route.autoCheckOut;
        this.model.restrictTruck = data.route.restrictTruck;
        this.model.restrictToTruck = data.route.restrictToTruck;
        if (!this.model.loadTruckFlag) {
          if (this.model.restrictToTruck === 1 ) {
            // Route is restricted — clear toTruck so the truck screen stays visible.
            // The readonly input shows the restricted truck; user presses Enter to confirm via toTruckScanned().
            this.model.toTruck = null;
            if (this.model.restrictTruck) {
              this.restrictedTruckDisplay = this.model.restrictTruck.id + ' | ' + this.model.restrictTruck.make;
            } else {
              this.restrictedTruckDisplay = '';
            }
          } else {
            // No restriction — load truck dropdown
            this.TruckService.getAllTrucks(null, this.model.branch, this.model.route, this.vaultDate, 100, 0)
              .then((res) => {
                this.model.allTrucks = res.results;
              })
              .catch((err) => {
                console.error(err);
              });
          }
        }
      })
      .then(() => {
        this.verifyShipment(finalRouteData, checkOutDate)
          .then(() => {
            if (this.isShipmentThrown) {
              this.Sound.playSuccessBeep("#success_beep");
              this.focusElementById('messenger-scan-id')
              this.model.messenger = ""
            }
          })
          .then(() => {
            this.getRouteTanker(this.model.route, this.vaultDate)
              .then((res) => {
                this.responseData = res.route;
              })
              .catch((err) => {
                console.log(err);
              })
          })
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.routeError();
          this.Modal.errorModal("error." + err.data.message);
          this.focusElementById('route-scan-id')
        }
      })
  }

  verifyShipment(routeId, vaultDate) {
    const defer = this.$q.defer();
    this.ScanService.shipmentVerify(routeId, vaultDate, this.coinCheckOut, this.model.branch)
      .then((data) => {
        this.remainingToThrow = data.remainingToThrow;
        if (this.remainingToThrow > 0) {
          this.routeError();
          this.focusElementById('route-scan-id');
          this.message = this.$translate.instant('error.' + 94013, {
            pendingToThrow: this.remainingToThrow
          })
          this.Modal.errorModal(this.message);
        }
        else {
          this.hasRoute = true;
          this.isShipmentThrown = true;
        }
        defer.resolve();
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.routeError();
          this.focusElementById('route-scan-id');
          this.Modal.errorModal("error." + err.data.message);
        }
      })
    return defer.promise;
  }

  routeError() {
    this.hasRoute = false;
    this.isShipmentThrown = false;
    this.Sound.PlayErrorBeep("#scanner_beep");
  }

  messengerScanned() {
    var finalMessengerData;
    if (this.model.messenger === '') {
      return;
    }

    // if (this.prefixes && this.prefixes.messenger) {
    //   if (this.model.messenger.startsWith(this.prefixes.messenger[0])) {
    //     finalMessengerData = this.model.messenger.slice(this.prefixes.messenger[0].length)
    //   } else {
    //     finalMessengerData = this.model.messenger;
    //   }
    // } else {
    //   finalMessengerData = this.model.messenger;
    // }

    finalMessengerData = this.model.messenger;
    this.ScanService.scanMessenger(this.model.branch, this.model.route, finalMessengerData, this.checkOutDate, false)
      .then((data) => {
        if (data.error) {
          this.focusElementById('messenger-scan-id')
          this.model.messenger = '';
          this.Modal.errorModal(data.error);
          throw new Error(data.error);
        }

        this.hasMessenger = true
        this.model.messenger = finalMessengerData;
        this.Sound.playSuccessBeep("#success_beep");
        if(this.model.routeObj && this.model.routeObj.scanUserItems === 1) {
        this.getCheckoutUserAssignedItems()
        }
      })
      .then(() => {
        if (!this.checkoutTruckLiability) {
          if ((!this.responseData && !this.routeVerifyData.requireThrow) || (!this.responseData && this.routeVerifyData.requireThrow)) {
            this.hasFromTanker = true;
            this.model.window = "";
            this.model.fromTanker = this.virtualTanker;
            this.focusElementById('window-scan-id')
          }
          else {
            this.focusElementById('from-tanker-id')
            this.model.fromTanker = '';
          }
        }
        else {
          this.focusElementById('truckId-scan-id')
        }
      })
      .then(() => {
        this.updateMessenger(this.model.messenger)
      })
      .catch((err) => {
        if (err.data.message) {
          this.model.messenger = '';
          finalMessengerData = '';
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.Modal.errorModal("error." + err.data.message)
          this.focusElementById('messenger-scan-id')
        }
      })
  }

  getCheckoutUserAssignedItems(){
    this.ScanService.getCheckoutUserAssignedItems(this.model.routeObj.routeId, this.model.branch, this.model.messenger)
      .then((res) => {
        this.logisticItemObj.remainingItemList = res.data.remainingItemList || [];
        this.logisticItemObj.remainingItemsCount = res.data.remainingItemList.length || 0;
        this.logisticItemObj.checkedOutItemList = res.data.checkedOutItemList || [];
        this.logisticItemObj.checkedOutItemsCount =res.data.checkedOutItemList.length || 0;
        this.logisticItemObj.availableItemList = res.data.availableItemList || [];
        this.logisticItemObj.availableItemCount = res.data.availableItemList.length || 0;
        this.remainingCheckoutItemCount = 0;
        this.remainingCashCheckoutItemCount = 0;
        this.remainingCoinCheckoutItemCount = 0;
        this.routeVerifyData.errorCount = 0;
        this.totalCoinVerified = 0;
        this.remainingToCheckedout = [];
        if (this.routeVerifyData.route) {
          this.routeVerifyData.route.forEach((record) => {
            if (!['OK_DELIVERY', 'OK_DELIVERY_ON_HOLD'].includes(record.message)) {
              if (this.coinCheckOut && ['E_DELIVERY_NOT_ON_HOLD'].includes(record.message)) this.remainingCheckoutItemCount++;
              if (!this.coinCheckOut) {
                if ( record.qty && record.coinFlag && !this.routeVerifyData.coinVerified) this.remainingCoinCheckoutItemCount = this.remainingCoinCheckoutItemCount + record.qty;
                else if (record.coinFlag && record.qty && this.routeVerifyData.coinVerified) this.totalCoinVerified = this.totalCoinVerified + record.qty;
                else if (!record.coinFlag && ['E_DELIVERY_NOT_ON_HOLD'].includes(record.message)) this.remainingCashCheckoutItemCount++;
              }
              this.remainingToCheckedout.push(record);
            }
            if (record.isError && ['E_COIN_SHIPMENT_NOT_VERIFIED', 'E_DELIVERY_NOT_ON_HOLD'].includes(record.message)) {
              this.routeVerifyData.errorCount++
            }
          })
          this.routeVerifyData.errorCount = this.routeVerifyData.errorCount + this.logisticItemObj.remainingItemsCount;
        }
    })
  }

  truckIDScanned() {
    var finalTruckIdData;
    if (this.model.truckId === '') {
      return;
    }
    finalTruckIdData = this.model.truckId;
    this.ScanService.scanTruckId(this.model.truckId)
      .then((data) => {
        if (data.error) {
          this.focusElementById('truckId-scan-id')
          this.model.truckId = '';
          this.finalTruckIdData = '';
          this.truckData = {};
          this.Modal.errorModal(data.error);
          throw new Error(data.error);
        }

        if ((!this.responseData && !this.routeVerifyData.requireThrow) || (!this.responseData && this.routeVerifyData.requireThrow)) {
          this.hasFromTanker = true;
          this.model.window = "";
          this.model.fromTanker = this.virtualTanker;
          this.focusElementById('window-scan-id')
        }
        else {
          this.focusElementById('from-tanker-id')
          this.model.fromTanker = '';
        }

        this.finalTruckIdData = finalTruckIdData;
        this.truckData = data.truck; 
        this.Sound.playSuccessBeep("#success_beep");
      })
      .catch((err) => {
        if (err.data.message) {
          this.model.truckId = '';
          finalTruckIdData = '';
          this.finalTruckIdData = '';
          this.truckData = {};
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.Modal.errorModal("error." + err.data.message)
          this.focusElementById('truckId-scan-id')
        }
      })
  }

  // Update scanned messengerId when doing checkout process
  updateMessenger(messenger) {
    this.RouteDetailService.routeUpdateDetails(this.branchId, this.model.route, this.valutDate, null, messenger, null, null, null, null, null, null)
      .then((data) => {
        // console.log(data);
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          return this.Modal.errorModal('error.' + err.data.message)
        }
      })
  }

  windowScanId() {
    this.hasFromTanker = true;
    this.model.window = "";
    if (this.setupData && this.setupData.virtualTankers && this.setupData.defaultFromTankerId && !this.model.fromTanker) {
      this.model.fromTanker = this.setupData.defaultFromTankerId;
      this.finalFromTankerData = this.setupData.defaultFromTankerId;
    } else {
      this.model.fromTanker = this.finalFromTankerData;
    }
    this.Sound.playSuccessBeep("#success_beep");
    return this.focusElementById('window-scan-id')
  }

  resetDataAndPlayBuzzer() {
    this.model.fromTanker = '';
    this.finalFromTankerData = '';
    this.Sound.PlayErrorBeep("#scanner_beep");
  }

  getRouteTanker(route, vaultDate) {
    return this.ScanService.scanFromTanker(route, vaultDate)
  }

  fromTankerScanned() {

    if (this.model.fromTanker === '') {
      return;
    }

    // if (this.prefixes && this.prefixes.tanker) {
    //   if (this.model.fromTanker.startsWith(this.prefixes.tanker[0])) {
    //     this.finalFromTankerData = this.model.fromTanker.slice(this.prefixes.tanker[0].length)
    //   } else {
    //     this.finalFromTankerData = this.model.fromTanker;
    //   }
    // } else {
    //   this.finalFromTankerData = this.model.fromTanker;
    // }

    this.finalFromTankerData = this.model.fromTanker;
    this.getRouteTanker(this.model.route, this.vaultDate)
      .then((res) => {
        this.response = res.route;
        if (this.response && this.response.id.toUpperCase() === this.model.fromTanker) {
          this.windowScanId();
        }
        else {
          this.resetDataAndPlayBuzzer();
          return this.Modal.errorModal("error." + 91304)
        }
      })
      .catch((err) => {
        if (err.data.message) {
          this.resetDataAndPlayBuzzer();
          return this.Modal.errorModal("error." + err.data.message)
        }
      })
  }

  windowScanned() {
    var finalWindowData;
    if (this.model.window === '') {
      return;
    }

    // if (this.prefixes && this.prefixes.window) {
    //     if (this.model.window.startsWith(this.prefixes.window[0])) {
    //       finalWindowData = this.model.window.slice(this.prefixes.window[0].length)
    //       console.log(finalWindowData);
    //     } else {
    //       finalWindowData = this.model.window;
    //       console.log(finalWindowData);
    //     }
    //   } 
    //   else {
    //     finalWindowData = this.model.window;
    //     console.log(finalWindowData);
    //   }

    finalWindowData = this.model.window;
    this.BranchService.get(this.user.branchId)
      .then((branchObj) => {
        this.hasWindow = branchObj.windows.some((window) => {
          return finalWindowData.toUpperCase() === window.id.toUpperCase();
        })

        if (this.hasWindow) {
          this.model.window = finalWindowData;
          if (!this.model.loadTruckFlag) {
            this.hasToTruck = this.model.toTruck;
          }

          if (this.model.loadTruckFlag) {
            if (this.setupData && this.setupData.virtualTankers && this.setupData.defaultToTankerId && !this.model.toTanker) {
              this.model.toTanker = this.setupData.defaultToTankerId;
              this.finalToTankerData = this.setupData.defaultToTankerId;
            }
            else {
              this.model.toTanker = '';
            }
            this.focusElementById('to-tanker-id')
            this.Sound.playSuccessBeep("#success_beep");
          }
        }
        else {
          this.model.window = '';
          finalWindowData = '';
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.Modal.errorModal("error." + 11000)
        }
      })
  }

  toTankerScanned() {

    if (this.model.toTanker === "") {
      return;
    }

    if (this.setupData.tankerId.toUpperCase() === this.model.toTanker) {
      this.resetToTanker();
      return this.Modal.errorModal('error.' + 90926)
    }
    else if (this.virtualTanker.toUpperCase() === this.model.toTanker) {
      this.resetToTanker();
      return this.Modal.errorModal('error.' + 90927);
    }
    else if (this.model.toTanker === this.model.fromTanker) {
      this.resetToTanker();
      return this.Modal.errorModal('error.' + 90929);
    }

    // this.ShipmentService.isValideTanker(this.model.toTanker, this.vaultDate)
    //   .then((res) => {
    //     if (!res.status) {
    //       this.resetToTanker();
    //       return this.Modal.errorModal("error." + 91307)
    //     }
    //     else {
    this.finalToTankerData = this.model.toTanker;
    const searchObj = this.getTankerSearchObj(this.finalToTankerData)

    this.LocationService.all(searchObj, 0, 1)
      .then((res) => {
        if (res.results && res.results.length) {
          this.hasToTanker = true;
          this.model.toTanker = this.finalToTankerData;
          this.Sound.playSuccessBeep("#success_beep");
          this.setFocus();
        }
        else {
          this.resetToTanker();
          return this.Modal.errorModal("error." + 91307)
        }
      })
      .catch((err) => {
        if (err.data.message) {
          this.resetToTanker();
          return this.Modal.errorModal("error." + err.data.message)
        }
      })
    // }
    // })
  }

  resetToTanker() {
    this.model.toTanker = '';
    this.finalToTankerData = '';
    this.Sound.PlayErrorBeep("#scanner_beep");
  }

  toTruckScanned() {

    // When route is restricted to a truck, the input is readonly/pre-filled.
    // Auto-set toTruck from the restricted truck so setTruckForRoute gets the right ID.
    if ((this.model.restrictToTruck === 1 || this.model.restrictToTruck === true) && this.model.restrictTruck) {
      this.model.toTruck = this.model.restrictTruck.id;
    }

    if (!this.model.toTruck || this.model.toTruck === "") {
      return;
    }

    this.TruckService.setTruckForRoute(this.model.toTruck, this.model.route, this.checkOutDate, this.model.branch)
      .then((res) => {
        if (res) {
          this.hasToTruck = true;
          this.setFocus();
        }
        else {
          this.model.toTruck = '';
          this.Sound.PlayErrorBeep("#scanner_beep");
          return this.Modal.errorModal("error." + 91309);
        }
      })
      .catch((err) => {
        if (err.data.message) {
          this.model.toTruck = '';
          this.Sound.PlayErrorBeep("#scanner_beep");
          return this.Modal.errorModal(err.data.message);
        }
      })
  }

  setDestination(destination) {
    this.isDestinationChanged = this.model.destination.value !== destination.value;
    this.newValues.destination = destination;
  }

  checkOutBag() {
    return this.ShipmentService.checkoutShipment(
      this.model.branch,
      this.model.bagId,
      this.model.route,
      this.checkOutDate,
      this.model.window,
      this.model.fromTanker,
      this.model.loadTruckFlag ? this.model.toTanker : this.model.toTruck
    )
      .then((response) => {
        if (response.error) {
          this.isError = true;
          return this.Modal.errorModal(response.error)
        }
        this.clearScan();
        this.Sound.playSuccessBeep("#success_beep");
      })
      .finally(() => {
        this.verifyRoute(this.model.route, this.checkOutDate)
        this.lastStatusUpdate = new Date();
      })
  }

  autoSubmit($event) {
    const bagScannedPromise = this.bagScanned($event);

    //in case of error bagScanned returns non promise values are returned there's a check for .then function
    if (bagScannedPromise && typeof bagScannedPromise.then === "function") {
      bagScannedPromise.then(() => {
        setTimeout(() => {
          this.bagSubmitted();
        }, 700)
      })
    }

    return bagScannedPromise
  }

  keyPressed(controlId, $event) {
    const ESC_KEY_CODE = 27;
    const BACKSPACE_KEY_CODE = 8;
    if (controlId === 'bagId') {
      if ($event.keyCode === ESC_KEY_CODE) {
        this.clearScan(true)
      }
      if ($event.keyCode === BACKSPACE_KEY_CODE && this.model.bagId && this.model.bagId.length <= 1) {
        this.clearScan(true)
      }
    }
  }

  bagSubmitted() {
    if (!this.model.bagId || this.isError) {
      this.isEventFired = false;
      return
    }
    const successMessage = this.$translate.instant('checkout.checkedout', {
      bagId: this.model.bagId.toString(),
      tankerId: this.model.loadTruckFlag ? this.model.toTanker : this.model.toTruck
    });

    this.isError = false;
    this.bagCheckOutMessage = '';
    this.bagIdCopy = ''
    return this.checkOutBag()
      .then(() => {
        this.bagIdCopy = this.lastScanned;
        this.isSuccessForceAddBag = false;
        this.bagCheckOutMessage = successMessage;
        this.isEventFired = false;
      })
      .catch((err) => {
        this.model.bagId = "";
        this.isSuccessForceAddBag = false;
        this.isError = true;
        this.isEventFired = false;
        if (err && err.data && err.data.message) {
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.bagCheckOutError = this.$translate.instant('error.' + err.data.message) || 'Error: ' + err.data.message;
        }
        else {
          this.bagCheckOutError = err.toString()
        }
      })
  }

  scanSuffix(value) {
    if (this.enterSuffix.length > 0 && value && value.toUpperCase().endsWith(this.enterSuffix)) {
      const bagIdLength = value.length;
      return value.slice(0, bagIdLength - this.enterSuffix.length)
    }
    else return value;
  }

  bagScanned($event) {
    this.model.bagId = this.scanSuffix(this.model.bagId);
    this.lastScanned = this.model.bagId;

    if (!this.model.bagId || this.isEventFired) {
      return;
    }

    this.bagScanLimitExceed = false;

    if (this.bagScanLimit && this.bagScanLimit > 0) {
      if (this.model.bagId.length > this.bagScanLimit && (!this.checkOnlyOnce || this.model.bagId.length !== this.checkLength)) {
        delete this.bagCheckOutError;
        delete this.bagCheckOutMessage;
        this.bagScanLimitExceed = true;
        this.checkOnlyOnce = true;
        this.checkLength = this.model.bagId.length;
        this.model.bagId = "";
        this.lastStatusUpdate = new Date();
        return this.bagScanError = this.$translate.instant('common.bagScanError')
      }
      else {
        this.checkLength = this.model.bagId.length > this.bagScanLimit ? this.model.bagId.length : this.bagScanLimit;
      }
    }

    delete this.lastStatusUpdate;
    if (this.bagIdCopy === this.model.bagId && this.isCheckOutSuccessful && this.wasItemFound) {
      this.isCheckOutSuccessful = false;
      this.isEventFired = true;
      return this.bagSubmitted()
    }
    else {
      this.bagIdCopy = this.model.bagId;
    }

    if (this.isSuccessForceAddBag) {
      this.model.bagId = this.lastScanned;
    }

    this.isError = false;
    this.wasItemFound = true;
    this.wasItemThrow = true;
    this.bagCheckOutError = '';
    this.disabledBag = true;
    return this.ShipmentService.verifyCheckoutShipment(
      this.model.branch,
      this.model.bagId,
      this.model.route,
      this.checkOutDate,
      this.model.window,
      this.model.fromTanker,
      this.model.loadTruckFlag ? this.model.toTanker : this.model.toTruck
    )
      .then((response) => {
        this.disabledBag = false;
        if (response.error) {
          this.lastStatusUpdate = new Date();
          this.isError = true;
          this.wasItemFound = false;
          if (response.errorCode == 91311 || response.message == '91311') {
            if (!this.addBagToCheckout) {
              this.model.bagId = "";
              return this.Modal.errorModal("Tracking ID does not exist.");
            } else {
              this.model.bagId = "";
              return this.forceAddBag($event);
            }
          }
          return this.Modal.errorModal(response.error)
        }
        if(response.shipment.inventoryBulkCoin){
          this.inventoryBulkCoin = true;
        }
        if (response.shipment.coinFlag && response.shipment.inventoryBulkCoin) {
          const shipment = response.shipment;
          this.ScanService.getCurrentDenomLedgerBalance(this.model.branch, 'Regular', [shipment], this.model.route, this.checkOutDate)
          .then((data) => {
              const balanceData = data && data.length > 0 
                ? data.find(item => 
                    Number(item.branchFundingSourceId) === Number(shipment.branchFundingSourceId) &&
                    item.denominationId === shipment.shiptypeId
                  ) || data[0]
                : null;

              if (balanceData && balanceData.alreadyDebited) {
                if (!this.shipmentData[shipment.branchFundingSourceId]) {
                    this.shipmentData[shipment.branchFundingSourceId] = {};
                }
                if (!this.shipmentData[shipment.branchFundingSourceId][shipment.shiptypeId]) {
                    this.shipmentData[shipment.branchFundingSourceId][shipment.shiptypeId] = {
                        amount: shipment.amount
                    };
                } else {
                    this.shipmentData[shipment.branchFundingSourceId][shipment.shiptypeId].amount += shipment.amount;
                }
                return;
              }

              let checkAmount = null;
              if (this.shipmentData && this.shipmentData[shipment.branchFundingSourceId] && this.shipmentData[shipment.branchFundingSourceId][shipment.shiptypeId] ) {
                 checkAmount = this.shipmentData[shipment.branchFundingSourceId][shipment.shiptypeId].amount + shipment.amount;
              } else {
                 checkAmount = shipment.amount;
              }
              
              const balance = balanceData ? Number(balanceData.balance) : 0;
              const amountToCheck = Number(checkAmount);
              
              if (!balanceData || amountToCheck > balance) {
                this.Sound.PlayErrorBeep("#scanner_beep");
                const message = this.$translate.instant('orderPacking.insufficient_coin', {
                    Denomination: shipment.shiptypeId,
                    BranchFundingSource: shipment.fundingSourceName
                });
                this.disabledBag = false;
                this.isEventFired = false;
                this.isCheckOutSuccessful = false;
                this.lastStatusUpdate = new Date();
                this.isError = true;
                this.clearItems($event)
                this.Modal.errorModal(message);
            } else {

              if (!this.shipmentData[shipment.branchFundingSourceId]) {
                  this.shipmentData[shipment.branchFundingSourceId] = {};
              }
          
              if (!this.shipmentData[shipment.branchFundingSourceId][shipment.shiptypeId]) {
                  this.shipmentData[shipment.branchFundingSourceId][shipment.shiptypeId] = {
                      amount: shipment.amount
                  };
              } else {
                  this.shipmentData[shipment.branchFundingSourceId][shipment.shiptypeId].amount += shipment.amount;
              }
          }
          })
          .catch((err) => {
            if (err && err.data && err.data.message) {
              this.Modal.errorModal(err.data.message)
            }
          })
      }
        if (this.checkoutTruckLiability && this.truckData && this.truckData.truckLiability) {
          this.ShipmentService.verifyTruckLiability(this.model.route, this.vaultDate, this.truckData.liabilityLimit, response.shipment.amount).then((data) => {
            if (!data.isWithinLiability) {
              this.disabledBag = false;
              this.isEventFired = false;
              this.Sound.PlayErrorBeep("#scanner_beep");
              this.isCheckOutSuccessful = false;
              this.lastStatusUpdate = new Date();
              this.isError = true;
              this.clearItems($event)
              return this.bagCheckOutError = this.$translate.instant('common.bagScanTruckError');
            }
          })
        }

        if (response.window.fuzzyMatching) {
          this.disabledBag = false;
          this.wasItemFound = false;
          // this.isEventFired = true;
          return this.Modal.checkedOutShipmentSelectionModal({
            bagId: this.model.bagId,
            branchId: this.model.branch,
            windowId: this.model.window,
            routeId: this.model.route,
            date: this.checkOutDate,
            tankerId: this.model.fromTanker,
            supervisorScan: !this.setupData.supervisorScan,
            disabledBag: this.disabledBag,
            cancelSupervisorChallenge: this.setupData.cancelSupervisorChallenge
          }, response.shipments, ({ modal, isCreated, selected }) => {
            const bagDefer = this.$q.defer();

            if (isCreated) {
              this.ShipmentService.create(selected)
                .then(() => {
                  bagDefer.resolve();
                })
                .catch((err) => {
                  bagDefer.reject(err);
                })
            }
            else {
              bagDefer.resolve();
            }

            bagDefer.promise
              .then(() => {
                this.isEventFired = false;
                this.model.bagId = selected.trackingId;
                this.autoSubmit($event);
                this.verifyRoute(this.model.route, this.checkOutDate)
                this.disabledBag = false;
                modal.close();
              })
              .catch((err) => {
                this.disabledBag = false;
                this.isEventFired = false;
                if (err && err.data && err.data.message) {
                  this.Sound.PlayErrorBeep("#scanner_beep");
                  return this.Modal.errorModal("error." + 90990);
                }
                else {
                  console.log(err);
                }
              })
          }, ({ modal }) => {
            modal.close();
            this.isEventFired = false;
            this.disabledBag = false;
            this.focusElementById('bagId');
          })
        }
        else {
          this.isCheckOutSuccessful = true;
          this.model.shipment = response.shipment;

          this.model.shipment.quantity = this.model.shipment.quantity || 1;
          this.disabledBag = false;
          this.focusElementById('bagId')
        }
        this.lastScanned = this.model.bagId;
      })
      .catch((err) => {
        this.focusElementById('bagId');
        // console.error(err);
        this.disabledBag = false;
        this.isEventFired = false;
        this.Sound.PlayErrorBeep("#scanner_beep");
        this.isCheckOutSuccessful = false;
        // this.model.bagId = '';
        this.lastStatusUpdate = new Date();
        this.isError = true;
        this.clearItems($event)

        if (err && err.data && err.data.message) {
          this.bagCheckOutError = this.$translate.instant('error.' + err.data.message) || null;
        }

        if (err && err.data && err.data.message === '91311') { //item not found
          this.disabledBag = false;
          this.wasItemFound = false;
          if (!this.addBagToCheckout) {
            this.model.bagId = "";
            return this.Modal.errorModal("Tracking ID does not exist.");
          } else {
            this.model.bagId = "";
            return this.forceAddBag($event);
          }
        }
        if (err && err.data && err.data.message === '91316') { // item remaining to throw
          this.wasItemThrow = false;
        }
        if (err && err.data && err.data.message === '91322') { // item remaining to throw
          this.isDisableRefreshButton = true;
          this.Modal.bagRemoveConfirmation({ bagId: this.lastScanned, cancelSupervisorChallenge: this.setupData.cancelSupervisorChallenge }, ({ modal, $scope }) => {
            if ($scope.isSupervisorConfirmed) {
              this.clearScan(true);
              this.clearItemScan();
              this.isDisableRefreshButton = false;
              this.remainingCheckoutItemCount = 0;
              this.remainingCashCheckoutItemCount = 0;
              this.remainingCoinCheckoutItemCount = 0;
              this.routeVerifyData.errorCount = 0;
              this.totalCoinVerified = 0;
              this.remainingToCheckedout = [];
              this.routeVerifyData.route = this.routeVerifyData.route.filter(t => t.trackingId !== this.lastScanned);
              this.routeVerifyData.route.forEach((record) => {
                  if (!['OK_DELIVERY', 'OK_DELIVERY_ON_HOLD'].includes(record.message)) {
                    if (this.coinCheckOut && ['E_DELIVERY_NOT_ON_HOLD'].includes(record.message)) this.remainingCheckoutItemCount++;
                    if (!this.coinCheckOut) {
                      if (record.qty && record.coinFlag  && !this.routeVerifyData.coinVerified) this.remainingCoinCheckoutItemCount = this.remainingCoinCheckoutItemCount + record.qty;
                      else if (record.coinFlag && record.qty && this.routeVerifyData.coinVerified) this.totalCoinVerified = this.totalCoinVerified + record.qty;
                      else if (!record.coinFlag && ['E_DELIVERY_NOT_ON_HOLD'].includes(record.message)) this.remainingCashCheckoutItemCount++;
                    }
                    this.remainingToCheckedout.push(record);
                  }
                  if (record.isError && ['E_COIN_SHIPMENT_NOT_VERIFIED', 'E_DELIVERY_NOT_ON_HOLD'].includes(record.message)) {
                    this.routeVerifyData.errorCount++
                  }
                })
              this.routeVerifyData.errorCount = this.routeVerifyData.errorCount + this.logisticItemObj.remainingItemsCount;
              modal.close();
            }
          }, ({ modal }) => {
            if (modal) modal.close();
          });
        }
        this.isSuccessForceAddBag = false;
      })
  }

  clearItems(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      this.disabledBag = false;
      this.model.bagId = "";
      // this.focusElementById('bag-id');
    };
  }

  // autoThrowTanker() {
  //   return new Promise(
  //     function (resolve, reject) {
  //          this.ShipmentService.throwTanker(this.model.branch, this.model.bagId, this.model.fromTanker, this.vaultDate, this.vaultDate)
  //         .then((data) => {
  //           console.log(this.model.branch, this.model.bagId, this.model.fromTanker, this.vaultDate, this.vaultDate);
  //           resolve(data);
  //         })
  //         .catch((err) => {
  //           if (err && err.data && err.data.message) {
  //             this.Sound.PlayErrorBeep("#scanner_beep");
  //             this.Modal.errorModal('error.' + err.data.message)
  //           }
  //           reject(err)
  //         })
  //     })
  // }

  autoThrow() {
    this.bagCheckOutMessage = "";
    this.model.bagId = this.lastScanned;
    this.ShipmentService.throwTanker(this.model.branch, this.model.bagId, this.model.fromTanker, this.vaultDate, this.loggedInUser)
      .then((data) => {
        // console.log(data);
      })
      .then(() => {
        return this.checkOutBag()
          .then(() => {
            const successMessage = this.$translate.instant('checkout.checkedout', {
              bagId: this.model.bagId.toString(),
              tankerId: this.model.loadTruckFlag ? this.model.toTanker : this.model.toTruck
            });
            this.isError = false;
            this.bagCheckOutMessage = successMessage;
          })
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.Modal.errorModal('error.' + err.data.message)
        }
      })
  }

  closeRoute() {
    if (this.isEventFired) return;
    this.isEventFired = true;
    this.model.loading = true;
    return this.RouteService.routeCheckout(
      this.model.branch,
      this.model.route,
      this.checkOutDate,
      this.model.fromTanker,
      this.model.loadTruckFlag ? this.model.toTanker : this.model.toTruck,
      this.model.window,
      this.model.messenger,
      this.model.routeDetailConfiguration
    )
      .then((data) => {
        this.routeCheckedOutData = data;
        this.isEventFired = false;
        this.model.loading = false;
        if (data.isError) {
          return this.Modal.errorModal(data.messageCode);
        }
        this.isInventoryBulkCoinOfCOD = !!data.coinDebitedDuringCheckout;
        this.releaseRoute(this.model.route)
        this.checkedoutRoute = this.model.route;
        this.lastStatusUpdate = new Date();
        this.zipSuffix = moment.utc(this.setupData.currentVaultDate).format('MMDDYY');
        this.Sound.playSuccessBeep("#success_beep");
        this.resetModel()
        if (this.isEnableMultiFunction) this.isCheckOutNextRoute = false;
        if (this.isCheckOutNextRoute) this.focusElementById('route-scan-id')
        return;
      })
      .catch((err) => {
        this.isEventFired = false;
        this.model.loading = false;
        if (!err) {
          return this.Modal.errorModal(`Lock Opening Still in process for route ${this.model.route}. This process can take a while, please check after some time.`)
        }
        else if (err && err.data && err.data.message) {
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.Modal.errorModal('error.' + err.data.message)
        }
        else {
          console.error(err);
        }
      });
  }

  releaseRoute(route) {
    this.executeReleaseRoutes([route])
      .then(() => {
      });
  }

  // update .zip after closing route
  executeReleaseRoutes(route) {

    return route.reduce((p, route) => {
      const nextIteration = this.$q.defer();

      p.then(() => {
        this.RouteService.releaseRoute(route, this.vaultDate, this.model.branch)
          .then((res) => {
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            nextIteration.resolve();
          });
      });

      return nextIteration.promise;
    }, this.$q.when())
      .finally(() => {
      });
  }

  // print checkout manifest 
  printManifest() {
    // const new_path = `${this.$location.protocol()}://${this.$location.host()}:${this.$location.port()}/print-checkout/${this.branchId}/${this.checkedoutRoute}/${this.vaultDate}`
    // this.$window.open(new_path, '_blank')

    const url = this.$state.href('printCheckout', {
      branchId: this.branchId,
      scannedRouteId: this.checkedoutRoute,
      date: this.vaultDate
    });

    window.w = window.open(url, '_blank');
    // window.w.printData = {
    //   itemList: this.logisticItemObj.checkedOutItemList
    // };
  }

  forceClose(event) {
    if (this.isEventFired) return;
    this.isEventFired = true;

    const filteredRouteVerifyData = {
      route: this.routeVerifyData.route.filter((record) => ['E_DELIVERY_NOT_ON_HOLD'].includes(record.message)),
      errorCount: this.routeVerifyData.errorCount,
      shipments: this.routeVerifyData.shipments
    };

    let coinFlag = 0, deliveryCoin = 0, isAllCoinVerified, coinIds = [];

    this.routeVerifyData.route.filter((d) => {
      if (d.coinFlag) coinFlag++;
      if (d.message === 'OK_DELIVERY_COIN') deliveryCoin++;

      if (d.message === 'E_COIN_SHIPMENT_NOT_VERIFIED') {
        coinIds.push(d.shiptypeId);
      }
    })

    isAllCoinVerified = coinFlag == deliveryCoin;

    this.Modal.forceCloseRoute(this.model.route, filteredRouteVerifyData, this.remainingCoinCheckoutItemCount,
      this.totalCoinShipmentOnRoute, this.coinCheckOut, isAllCoinVerified, this.logisticItemObj.remainingItemList,
      ({ $scope, action, modal, scanValue }) => {
        this.isEventFired = false;
        if (action === 'scan') {
          this.model.bagId = "";
          // this.bagScanned()
          modal.close();
          this.setFocus();
          return;
        }

        let holdShipmentObj = [{
          branch: this.model.branch,
          route: this.model.route,
          checkOutDate: this.checkOutDate,
          supervisorId: $scope.model.supervisorId,
          comment: '',
          routeVerifyResults: $scope.model.routeVerifyResults
        }];

    this.RouteService.validateLedgerBalanceAgainstRouteCoinHandler(this.model.route, this.vaultDate)
      .then((res) => {
        this.ShipmentService.bulkHoldShipment(holdShipmentObj)
          .then(() => this.logisticItemBulkHold())
          .then(() => this.ScanService.verifyCoin(this.model.route, this.vaultDate).then((data) => {
            if (data) {
              this.isInventoryBulkCoinOfCOD = data.results.allCoins.some(item => item.inventoryBulkCoin === 1 && item.codInputValue > 0);
            }
          }))
          .then(() => {
            if (this.totalCoinShipmentOnRoute > 0 && !isAllCoinVerified) {
              return this.verifyCoin(this.model.route, this.vaultDate, this.model.branch, coinIds)
                .then(() => {
                  return this.routeCheckOut(this.model.route, this.checkOutDate)
                })
            }
          })
          .then(() => {
            if (this.totalCoinShipmentOnRoute == 0 || isAllCoinVerified) {
              return this.routeCheckOut(this.model.route, this.checkOutDate)
            }
          })
          .catch((err) => {
            if (err && err.data && err.data.message) {
              this.Sound.PlayErrorBeep("#scanner_beep");
              return this.Modal.errorModal('error.' + err.data.message);
            }
          })
          .finally(() => {
            $scope.loading = false;
            modal.close();
          });
      })
      .catch((err) => {
        this.isEventFired = false;
        if (err && err.data && err.data.message) {
          this.Sound.PlayErrorBeep("#scanner_beep");
          return this.Modal.errorModal(err.data.message);
        }
        else {
          this.Modal.errorModal(err);
        }
      })
      }, ({ modal }) => {
        this.isEventFired = false;
        if (modal) modal.close();
      }, undefined, this.model.routeObj.name)
  }

  routeCheckOut(route, date) {
    return this.verifyRoute(route, date)
      .then(() => {
        if (!this.routeVerifyData.errorCount) {
          this.closeRoute();
        }
      })
  }

  forceAddBag($event) {
    const user = this.User.getUser();
    const isSupervisor = user && user.supervisor;
    const supervisorScanRequired = isSupervisor ? this.setupData.supervisorScan : true;

    return this.Modal.checkedoutForceAddBag({
      bagId: this.lastScanned,
      branchId: this.model.branch,
      windowId: this.model.window,
      routeId: this.model.route,
      date: this.checkOutDate,
      tankerId: this.model.fromTanker,
      supervisorScan: supervisorScanRequired,
      disabledBag: this.disabledBag,
      cancelSupervisorChallenge: this.setupData.cancelSupervisorChallenge
    }, ({ modal, $scope, disabledBag }) => {
      this.isDisabledBag = disabledBag;
      $scope.bag.routeId = this.model.route
      $scope.bag.pickupDate = this.checkOutDate
      // $scope.bag.packedFlag = true
      this.ShipmentService.create($scope.bag)
        .then((res) => {
          this.isSuccessForceAddBag = true;
          this.isEventFired = false;
          this.model.bagId = this.lastScanned;
          modal.close();
          this.autoSubmit($event)
          this.wasItemFound = true;
          this.bagCheckOutError = '';
          this.bagCheckOutMessage = '';
          this.lastStatusUpdate = '';
          this.isError = '';
          this.disabledBag = disabledBag;
          this.verifyRoute(this.model.route, this.checkOutDate)
        })
        .catch((err) => {
          this.lastScanned = "";
          this.model.bagId = ""
          this.disabledBag = disabledBag;
          this.isSuccessForceAddBag = false;
          if (err && err.data && err.data.errors) {
            this.Sound.PlayErrorBeep("#scanner_beep");
            this.Modal.errorModal("error." + err.data.errors[0].path);
          }
          else if (err && err.data && err.data.message) {
            this.Sound.PlayErrorBeep("#scanner_beep");
            this.Modal.errorModal(err.data.message);
          }
          else {
            console.log(err);
          }
        });
    }, ({ modal }) => {
      this.focusElementById('bagId');
      this.isEventFired = false;
      this.model.bagId = ""
      this.disabledBag = false;
      modal.close();
    });
  }

  // Add items modal
  addItems() {
    this.Modal.checkoutAddItems(({ modal }) => { },
      ({ modal }) => {
        modal.close();
      });
  }

  clearScan(clearError) {
    this.model.shipment = {};
    this.model.bagId = '';

    if (clearError) {
      this.lastStatusUpdate = undefined;
      this.bagCheckOutError = '';
      this.bagCheckInMessage = '';
      this.isError = false;
    }
    this.isEventFired = false;
    this.isSuccessForceAddBag = false;
    this.bagScanLimitExceed = false;
    this.checkOnlyOnce = false;
    this.disabledBag = false;
    this.shipmentAssociateToTankerList = [];
    this.model.scannedTankerId = '';
    this.setFocus();
  }

  resetModel() {
    this.hasMessenger = false
    this.hasRoute = false;
    this.isShipmentThrown = true;
    this.hasWindow = false
    this.hasFromTanker = false;
    this.hasToTanker = false;
    this.hasToTruck = false;

    this.model = {
      route: undefined,
      branch: this.User.getUser().branchId,
      window: undefined,
      fromTanker: undefined,
      toTanker: undefined,
      toTruck: undefined,
      loadTruckFlag: false,
      messenger: undefined,
      truckId: undefined,
    }

    this.isError = false;
    this.bagCheckOutError = '';
    this.bagCheckOutMessage = '';
  }

  // coinShipTypes() {
  //   this.ShipmentService.getCoinShiptypes(this.model.route, this.vaultDate)
  //     .then((data) => {
  //       this.shipTypeList = data.results;
  //       this.total = data.total;
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     })
  // }

  // showCoinShiptypes() {
  //   this.Modal.coinShiptypeList(this.shipTypeList, this.total, ({ modal, totalCoinShiptype }) => {
  //   }, ({ modal }) => {
  //     modal.close();
  //   });
  // }

  shipmentInfo(isShpCheckedOut, field, status) {
    // console.log(isShpCheckedOut, field);
    let isCoinVerified = this.routeVerifyData.coinVerified;
    this.Modal.routeCheckoutInfo(isShpCheckedOut, this.model.route, this.vaultDate, this.model.branch, this.remainingToCheckedout, field, isCoinVerified, status, ({ modal }) => {
      modal.close();
    }, ({ modal }) => {
      modal.close();
    })
  }

  AutoOptimizeRoute() {
    // console.log(this.vaultDate, this.model.branch, this.checkedoutRoute, this.date);
    this.Modal.routeSequenceModal(this.date, this.checkedoutRoute, this.model.branch, ({ modal, routeSequence }) => {
      this.RouteStopService.updateRouteStop(routeSequence, this.model.branch) // update route Sequence
        .then((data) => {
          return this.routeStopTransfer([this.checkedoutRoute])
            .then(() => {
              modal.close();
              this.optimizedStops = data.updatedStops;
            })
        })
        .catch((err) => {
          if (err && err.data && err.data.message) {
            return this.Modal.errorModal('error.' + err.data.message);
          }
        })
    }, ({ modal }) => {
      modal.close();
    })
  }

  routeStopTransfer(routes) {
    const defer = this.$q.defer();
    // this.RouteService.routeStopTransfered(routes, this.vaultDate, this.model.branch)
    this.RouteService.routeStopTransfered([{ routeId: routes, date: this.vaultDate }], this.model.branch)
      .then((data) => {
        defer.resolve();
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          return this.Modal.errorModal('error.' + err.data.message);
        }
        defer.reject(err);
      })
    return defer.promise;
  }

  closeInfo() {
    this.isCheckOutNextRoute = true;
    this.optimizedStops = null;
    this.checkedoutRoute = null;
    this.focusElementById('route-scan-id');
  }

  checkOutNextRoute() {
    this.isCheckOutNextRoute = true;
    this.optimizedStops = null;
    this.checkedoutRoute = null;
    this.model.stats = 'cash';
    this.model.routeDetailConfiguration = 'messenger';
    this.focusElementById('route-scan-id');
  }

  autoGenerateAtmCodes() {
    const data = {
      routeId: this.checkedoutRoute,
      vaultDate: this.vaultDate,
      redirectFromCheckoutScreen: true
    }
    this.DataCounter.setAtmCodeData(data);
    this.$location.url('/app/atm-codes-management');
  }

  tabSelection(selectedValue) {
    this.model.stats = selectedValue;
  }

  verifyCoinShipment() {
    this.Modal.coinShiptypeList(this.model.route, this.vaultDate, this.model.branch, ({ modal , isCodInventoryBulkCoin, coinIds }) => {
     this.isInventoryBulkCoinOfCOD = isCodInventoryBulkCoin;
      this.verifyCoin(this.model.route, this.vaultDate, this.model.branch, coinIds)
        .then(() => {
          modal.close();
          this.verifyRoute(this.model.route, this.checkOutDate)
        })
    }, ({ modal }) => {
      modal.close();
    });
  }

  verifyCoin(routeId, vaultDate, branchId, coinIds = []) {
    const defer = this.$q.defer();
    this.ScanService.verifyRouteCoin(routeId, vaultDate, branchId, coinIds)
      .then((res) => {
        defer.resolve();
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message)
        }
      })
    return defer.promise;
  }

  scanPrefix(prefixType, field) {
    if (this.model[field] && this.prefixes && this.prefixes[prefixType]) {
      if (this.model[field].startsWith(this.prefixes[prefixType][0])) {
        this.model[field] = this.model[field].slice(this.prefixes[prefixType][0].length).trim();
      }
    }
  }

  scanTankerId() {
    if (!this.model.scannedTankerId) return;

    this.lastStatusUpdate = undefined;
    this.shipmentAssociateToTankerList = this.remainingToCheckedout.filter((s) => s.tankerId == this.model.scannedTankerId);

    if (this.shipmentAssociateToTankerList.length == 0) {
      const errorMsg = this.$translate.instant('checkout.tanker_association_error', { tankerId: this.model.scannedTankerId });
      this.Modal.errorModal(errorMsg);
    }
  }

  shipmentAssociateToTankerModal() {
    this.Modal.shipmentAssociateToTanker(this.shipmentAssociateToTankerList, this.model.scannedTankerId, ({ modal, $scope }) => {
      const trackingIds = this.shipmentAssociateToTankerList.map(d => d.trackingId);

      $scope.model.loading = true;
      return this.ShipmentService.checkoutShipment(
        this.model.branch,
        trackingIds,
        this.model.route,
        this.checkOutDate,
        this.model.window,
        this.model.fromTanker,
        this.model.loadTruckFlag ? this.model.toTanker : this.model.toTruck
      )
        .then(() => {
          this.clearScan();
          this.Sound.playSuccessBeep("#success_beep");
          this.verifyRoute(this.model.route, this.checkOutDate);
        })
        .catch((err) => {
          if (err && err.data && err.data.message) {
            this.Modal.errorModal('error.' + err.data.message);
          }
        })
        .finally(() => {
          modal.close();
          $scope.model.loading = false;
        })
    }, ({ modal }) => {
      modal.close();
    })
  }

  checkoutTabSelection(selectedValue) {
    this.currentCheckoutTab = selectedValue;
    if (this.currentCheckoutTab === this.checkoutTab.items) {
      this.clearItemScan();
      this.model.stats = this.stats.items;
    }
    else if (this.currentCheckoutTab === this.checkoutTab.shipment) {
      this.clearScan();
      this.model.stats = this.stats.cash;
    }
  }

  remainingLogisticItemList() {
    this.Modal.logisticItemList(this.model.route, this.logisticItemObj.remainingItemList, 'remaining', ({ modal }) => {
      modal.close();
    }, ({ modal }) => {
      modal.close();
    });
  }

  logisticItemCheckedOutList() {
    this.Modal.logisticItemList(this.model.route, this.logisticItemObj.checkedOutItemList, 'checkedOut', ({ modal }) => {
      modal.close();
    }, ({ modal }) => {
      modal.close();
    });
  }

  availableLogisticItems() {
    this.Modal.logisticItemList(this.model.route, this.logisticItemObj.availableItemList, 'available', ({ modal }) => {
      modal.close();
    }, ({ modal }) => {
      modal.close();
    });
  }

  clearItemScan() {
    this.logisticItemObj.barcode = null;
    this.logisticItemObj.itemScanLimitExceed = false;
    this.logisticItemObj.allowItemScanOnce = false;
    this.logisticItemObj.disableItemScan = false;
    this.logisticItemObj.defaultLength = 0;
    this.logisticItemObj.lastUpdated = null;
    this.logisticItemObj.lastScannedItem = null;
    this.logisticItemObj.isError = false;
    this.logisticItemObj.itemCheckOutError = null;
    this.logisticItemObj.itemCheckOutMessage = null;
    this.logisticItemObj.itemScanError = null;
    this.logisticItemObj.itemDetails = {};
    this.logisticItemObj.wasItemFound = false;
    this.logisticItemObj.errorCode = null;
    this.logisticItemObj.loading = false;
    this.setFocus();
  }

  itemScanKeyPress($event) {
    const ESC_KEY_CODE = 27;
    const BACKSPACE_KEY_CODE = 8;
    if ($event.keyCode === ESC_KEY_CODE) return this.clearItemScan();
    if ($event.keyCode === BACKSPACE_KEY_CODE && this.logisticItemObj.barcode && this.logisticItemObj.barcode.length <= 1) return this.clearItemScan();
  }

  logisticItemScan() {
    this.logisticItemObj.barcode = this.scanSuffix(this.logisticItemObj.barcode);

    if (!this.logisticItemObj.barcode) return;

    this.logisticItemObj.itemScanLimitExceed = false;
    this.logisticItemObj.isError = false;
    this.logisticItemObj.itemCheckOutMessage = null;

    if (this.bagScanLimit && this.bagScanLimit > 0) {
      if (this.logisticItemObj.barcode.length > this.bagScanLimit &&
        (!this.logisticItemObj.allowItemScanOnce || this.logisticItemObj.barcode.length !== this.logisticItemObj.defaultLength)) {
        delete this.logisticItemObj.itemCheckOutError;
        delete this.logisticItemObj.itemCheckOutMessage;
        delete this.logisticItemObj.errorCode;
        this.logisticItemObj.itemScanLimitExceed = true;
        this.logisticItemObj.allowItemScanOnce = true;
        this.logisticItemObj.lastScannedItem = this.logisticItemObj.barcode;
        this.logisticItemObj.defaultLength = this.logisticItemObj.barcode.length;
        this.logisticItemObj.barcode = "";
        this.logisticItemObj.isError = true;
        this.logisticItemObj.lastUpdated = new Date();
        return this.logisticItemObj.itemScanError = this.$translate.instant('common.bagScanError');
      }
      else {
        this.logisticItemObj.defaultLength = this.logisticItemObj.barcode.length > this.bagScanLimit ? this.logisticItemObj.barcode.length : this.bagScanLimit;
      }
    }

    this.logisticItemObj.itemDetails = this.logisticItemObj.remainingItemList.find(item => item.barcode.toUpperCase() == this.logisticItemObj.barcode);
    if (this.logisticItemObj.itemDetails) this.logisticItemObj.wasItemFound = true;
    else if (_.isEmpty(this.logisticItemObj.itemDetails)) this.logisticItemObj.wasItemFound = false;

    delete this.logisticItemObj.lastUpdated;
    if (!this.autoSubmitItem) {
      if (this.logisticItemObj.barcodeCopy === this.logisticItemObj.barcode && this.logisticItemObj.wasItemFound) {
        this.logisticItemObj.isItemCheckedOut = false;
        return this.logisticItemSubmitted();
      }
      else if (!this.logisticItemObj.wasItemFound) {
        this.logisticItemObj.barcodeCopy = this.logisticItemObj.barcode;
        return this.forceAddItem();
      }
      else {
        this.logisticItemObj.barcodeCopy = this.logisticItemObj.barcode;
      }
    }
    else if (this.autoSubmitItem){ 
      this.logisticItemObj.barcodeCopy = this.logisticItemObj.barcode;
      return Promise.resolve();
    }
  }

  logisticItemSubmitted() {
    if (!this.logisticItemObj.barcode) return;
    const successMessage = this.$translate.instant('item.checked_out');

    return this.ItemService.logisticItemCheckOut(this.branchId, this.logisticItemObj.barcode, this.user.id)
      .then(() => {
        this.logisticItemObj.itemCheckOutMessage = successMessage;
        this.logisticItemObj.isItemCheckedOut = true;
        this.logisticItemObj.itemDetails = {};
        this.verifyRoute(this.model.route, this.checkOutDate);
      })
      .catch((err) => {
        this.logisticItemObj.isItemCheckedOut = false;
        this.logisticItemObj.isError = true;
        if (err && err.data && err.data.message) {
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.logisticItemObj.errorCode = err.data.message;
          this.logisticItemObj.itemCheckOutError = this.$translate.instant('error.' + err.data.message) || 'Error: ' + err.data.message;
        }
        else {
          this.logisticItemObj.itemCheckOutError = err.toString();
        }
      })
      .finally(() => {
        this.logisticItemObj.barcode = null;
        this.logisticItemObj.lastUpdated = new Date();
        this.logisticItemObj.lastScannedItem = this.logisticItemObj.barcodeCopy;
        this.logisticItemObj.barcodeCopy = null;
      })
  }

  autoSubmitItems($event) {
    const promise = this.logisticItemScan($event);
    
    if (promise && typeof promise.then === "function") {
      promise.then(() => {
        setTimeout(() => {
          if (this.logisticItemObj.wasItemFound) return this.logisticItemSubmitted();
          else if (!this.logisticItemObj.wasItemFound) return this.forceAddItem();
        }, 700)
      })
    }

    return promise;
  }

  logisticItemBulkHold() {
    return this.ItemService.logisticItemBulkHold(this.model.route, this.branchId, this.vaultDate, this.user.id, this.logisticItemObj.remainingItemList)
      .then().catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message)
        }
      })
  }

  setFocus() {
    if (this.currentCheckoutTab === this.checkoutTab.items) {
      this.focusElementById('barcode');
    }
    else if (this.currentCheckoutTab === this.checkoutTab.shipment) {
      this.focusElementById('bagId');
    }
  }

  refreshData() {
    this.model.refreshItems = true;
    this.verifyRoute(this.model.route, this.checkOutDate)
      .then(() => {
        this.clearScan(true);
        this.clearItemScan();
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal('error.' + err.data.message)
        }
      })
      .finally(() => {
        this.model.refreshItems = false;
      })
  }

  forceAddItem() {
    this.logisticItemObj.loading = true;

    const successMessage = this.$translate.instant('item.checked_out');
    const userKey = null;

    return this.ItemService.logisticItemForceAdd(this.branchId, this.logisticItemObj.barcodeCopy, this.user.id, this.model.route, null, false, userKey)
      .then(() => {
        this.logisticItemObj.itemCheckOutMessage = successMessage;
        this.logisticItemObj.isItemCheckedOut = true;
        this.logisticItemObj.itemDetails = {};
        this.logisticItemObj.errorCode = null;
        this.logisticItemObj.isError = false;
        this.logisticItemObj.itemCheckOutError = null;
        this.verifyRoute(this.model.route, this.checkOutDate);
      })
      .catch((err) => {
        this.logisticItemObj.isItemCheckedOut = false;
        this.logisticItemObj.isError = true;
        if (err && err.data && err.data.message) {
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.logisticItemObj.itemCheckOutError = this.$translate.instant('error.' + err.data.message) || 'Error: ' + err.data.message;
        }
        else {
          this.logisticItemObj.itemCheckOutError = err.toString();
        }
      })
      .finally(() => {
        this.logisticItemObj.barcode = null;
        this.logisticItemObj.lastUpdated = new Date();
        this.logisticItemObj.lastScannedItem = this.logisticItemObj.barcodeCopy;
        this.logisticItemObj.barcodeCopy = null;
        this.logisticItemObj.loading = false;

        this.setFocus();
      })
  }

}

export default CheckOutController



// WEBPACK FOOTER //
// ./client/app/components/checkout/checkout.controller.js